export default {
    state: {
        restrictions: [],
        consumerFamilies: [],
        familyProducts: []
    },
    mutations: {
        setFoodRestrictions (state, data) {
            state.restrictions = data
        },
        setConsumerFamilies (state, data) {
            state.consumerFamilies = data
        },
        setFamilyProducts (state, data) {
            state.familyProducts = data
        }
    },
    actions: {
        setFoodRestrictions ({ commit }, data) {
            commit('setFoodRestrictions', data)
        },
        setConsumerFamilies ({ commit }, data) {
            commit('setConsumerFamilies', data)
        },
        setFamilyProducts ({ commit }, data) {
            commit('setFamilyProducts', data)
        }
    },
    getters: {
        getFoodRestrictions: (state) => state.restrictions,
        getConsumerFamilies: (state) => state.consumerFamilies,
        getFamilyProducts: (state) => state.familyProducts
    }
}
